"use strict";
exports.__esModule = true;
exports.CLASS_HIDDEN = exports.COLOR_OPTIONS = exports.CACHE_DATA_KEY = exports.CACHE_DATE_KEY = exports.CONTENT_BLOCK_SELECTOR = exports.FACET_SELECT_SELECTOR = exports.FACET_CHECKBOX_SELECTOR = exports.PRODUCT_THUMBNAILS_SELECTOR = exports.HANDLES_CONTAINER_SELECTOR = exports.JSON_CONTAINER_SELECTOR = exports.PRODUCTS_CONTAINER_SELECTOR = exports.FACET_CHECKBOX_OPTION = exports.COLLECTION_HANDLE_PER_PAGE = exports.COLLECTION_HANDLE_ATTR = void 0;
//Attributes
exports.COLLECTION_HANDLE_ATTR = 'data-collection-handle';
exports.COLLECTION_HANDLE_PER_PAGE = 'data-collection-per-page';
exports.FACET_CHECKBOX_OPTION = 'data-option';
//Selectors
exports.PRODUCTS_CONTAINER_SELECTOR = '[data-collection-template-products]';
exports.JSON_CONTAINER_SELECTOR = '[data-collection-json]';
exports.HANDLES_CONTAINER_SELECTOR = '[data-collection-handles]';
exports.PRODUCT_THUMBNAILS_SELECTOR = '[data-product-thumbnail]';
exports.FACET_CHECKBOX_SELECTOR = '[data-facet-checkbox]';
exports.FACET_SELECT_SELECTOR = '[data-facet-select]';
exports.CONTENT_BLOCK_SELECTOR = '[data-content-block]';
//Other strings
exports.CACHE_DATE_KEY = 'AjaxCollectionProductCacheTime';
exports.CACHE_DATA_KEY = 'AjaxCollectionProductCacheData';
exports.COLOR_OPTIONS = ['Color', 'Colour'];
exports.CLASS_HIDDEN = 'is-hidden';
//# sourceMappingURL=Constants.js.map